import { API_CONFIG, PRODUCTION, UAT } from "common/config";
import { COMMON_JS } from "common/scripts";

const local = PRODUCTION === "false" && UAT === "false";
const LOCAL_PORT = "7001";

export const AI_APIS = {
  getScavengeRoute: async (args: any = {}) => {
    let resObj: any = {};
    let apiUrl = "/ai/v1/ZPSTN0F1AMPY4X8C";
    if (local) {
      apiUrl = API_CONFIG.API_URL + ":7002" + apiUrl;
    }

    const response = await COMMON_JS.callApi(
      apiUrl,
      API_CONFIG.METHODS.POST,
      args,
      false,
      local
    );
    return response;
  },
};
